//
// DataTreeNode.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import ClosetObject from "../../../ClosetObject";
import "../../../lib";
import "../DataValue";
import "../Aggregator";

var DataTreeNode = createModule("commons::DataTreeNode", [], ClosetObject, [
    ,
    ,
    ,
    {
        measureValues: [1],
        rowIndexVector: [4],
        children: [1],
        formattedValue: 7,
        measureAggregators: [1],
        measureNames: [7],
        value: 1,
    },
    {
        getParent: [1],
        getDepth: [3],
        isCollapsed: [2],
        isRoot: [2],
        _getUniqueNodePath_n: [[1],3],
        getParentNodeAtLevel: [1,3],
        removeChild: [0,1],
        getNumberOfMeasures: [3],
        getChildNodesAtLevel: [[1],3],
        getNodeFromChildNodePath: [1,[1]],
        isLeaf: [2],
        getNumberOfChildren: [3],
        getLevel: [3],
        isLastChild: [2],
        getLeafNodes: [[1]],
        isFirstChild: [2],
        getChildForFormattedValue: [1,7],
        getRoot: [1],
        _getUniqueNodePath_v: [[1]],
        addChild: [0,1],
    },
    {
        _create: [4,7,1],
    },
    ["getUniqueNodePath"],
]);
export default DataTreeNode;
